<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 85%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="角色名称">
          <a-input placeholder="请输入角色名称" v-decorator="[ 'roleName', validatorRules.roleName]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="角色类型">
         <j-dict-select-tag disabled :trigger-change="true" type="list" v-decorator="[ 'roleType',validatorRules.roleType]" placeholder="请选择角色类型"  dictCode="role_type"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="计划类型">
         <j-dict-select-tag :trigger-change="true" type="list" v-decorator="[ 'planType',validatorRules.planType]"  dictCode="role_plan_type"   @change="planTypeChange" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否临时任务">
         <a-radio-group  v-decorator="[ 'hasTemporaryTasks',validatorRules.hasTemporaryTasks]" :options="[{ label: '是', value: '1',key:'是' },{ label: '否', value: '0',key:'否'  }]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon"
          label="是否设置上下午">
         <a-radio-group @change="hasNoonChange" v-decorator="[ 'hasNoon',validatorRules.hasNoon]" :options="[{ label: '是', value: '1',key:'是' },{ label: '否', value: '0',key:'否'  }]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="!showHasNoon||!hasNoonValue"
          label="开始时间">
          <a-time-picker format="HH:mm"  v-decorator="[ 'startTime',validatorRules.startTime]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="!showHasNoon||!hasNoonValue"
          label="结束时间">
          <a-time-picker format="HH:mm"  v-decorator="[ 'endTime',validatorRules.endTime]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon&&hasNoonValue"
          label="上午次数">
          <a-input-number size="large" :min="1" :max="10"  v-decorator="[ 'morningPlanNum',validatorRules.morningPlanNum]"  @change="noonValueChangeMorning" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon&&hasNoonValue"
          label="上午开始时间">
          <a-time-picker format="HH:mm"  v-decorator="[ 'morningStartTime',validatorRules.morningStartTime]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon&&hasNoonValue"
          label="上午结束时间">
          <a-time-picker format="HH:mm"  v-decorator="[ 'morningEndTime',validatorRules.morningEndTime]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon&&hasNoonValue"
          label="下午次数">
          <a-input-number size="large" :min="1" :max="10"  v-decorator="[ 'afternoonPlanNum',validatorRules.afternoonPlanNum]"  @change="noonValueChangeAfternoon" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon&&hasNoonValue"
          label="下午开始时间">
          <a-time-picker format="HH:mm"   v-decorator="[ 'afternoonStartTime',validatorRules.afternoonStartTime]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon&&hasNoonValue"
          label="下午结束时间">
          <a-time-picker format="HH:mm"   v-decorator="[ 'afternoonEndTime',validatorRules.afternoonEndTime]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="计划次数">
            <a-input-number   size="large" :min="1" :max="20"  v-decorator="[ 'planNum',validatorRules.planNum]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否开启5S专员">
         <a-radio-group  :disabled="true"  v-decorator="[ 'hasFives',validatorRules.hasFives]" :options="[{ label: '是', value: '1',key:'是' },{ label: '否', value: '0',key:'否'  }]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="启用任务推迟取消">
         <a-radio-group @change="handleHasDelayCancelChange" v-decorator="[ 'hasDelayCancel',validatorRules.hasDelayCancel]" :options="[{ label: '是', value: '1',key:'是' },{ label: '否', value: '0',key:'否'  }]"  />
        </a-form-item>
        <a-form-item
          v-show="isShowDelayCancel"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="推迟次数">
            <div  class="div-flex"  >
              <a-input-number     size="large" :min="0" :max="100"  v-decorator="[ 'delayNum',validatorRules.delayNum]"  />
              <p  class="input-addonafter-count"  >次数/月</p>
            </div>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="isShowDelayCancel"
          label="取消次数">
            <div  class="div-flex"  >
              <a-input-number   size="large" :min="0" :max="100"  v-decorator="[ 'cancelNum',validatorRules.cancelNum]" />
              <p  class="input-addonafter-count"  >次数/月</p>
            </div>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="启用巡查时间限制">
         <a-radio-group  @change="handleHasTimeMinMaxChange" v-decorator="[ 'hasTimeMinMax',validatorRules.hasTimeMinMax]" :options="[{ label: '是', value: '1',key:'是' },{ label: '否', value: '0',key:'否'  }]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="isShowTimeMinMax"
          label="最小巡查时间">
            <div   class="div-flex"  >
              <a-input-number   size="large" :min="0" :max="300"  v-decorator="[ 'inspectionMinTime',validatorRules.inspectionMinTime]"  />
              <p  class="input-addonafter-count"  >分钟</p>
            </div>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="isShowTimeMinMax"
          label="最大巡查时间">
            <div   class="div-flex"  >
              <a-input-number   size="large" :min="0" :max="300"  v-decorator="[ 'inspectionMaxTime',validatorRules.inspectionMaxTime]"/>
              <p  class="input-addonafter-count"  >分钟</p>
            </div>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="禁止生成任务">
         <a-radio-group  v-decorator="[ 'noAutoCreateTask',validatorRules.noAutoCreateTask]" :options="[{ label: '是', value: '1',key:'是' },{ label: '否', value: '0',key:'否'  }]"  />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import {editInspectionRoleOfGeneral,duplicateCheck} from '@/api/api'
  import moment from 'moment';
  export default {
    name: "RoleModal",
    data () {
      return {
        hasNoonValue:false,
        showHasNoon:false,
        title:"操作",
        visible: false,
        roleDisabled: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          roleName:{
            rules: [
              { required: true, message: '请输入角色名称!' },
              { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
            ]},
          roleCode:{
            rules: [
              { required: true, message: '请输入角色名称!'},
              { min: 0, max: 64, message: '长度不超过 64 个字符', trigger: 'blur' },
              { validator: this.validateRoleCode}
            ]},
          description:{
            rules: [
              { min: 0, max: 126, message: '长度不超过 126 个字符', trigger: 'blur' }
            ]},
          roleType:{
            initialValue:""
          },
          planType:{
            initialValue:""
          },
          hasNoon:{
            initialValue:"0"
          },
          hasTemporaryTasks:{
            initialValue:"0"
          },
           planNum:{
            initialValue:1,
          },
          morningPlanNum:{
            initialValue:1,
          },
          afternoonPlanNum:{
            initialValue:1,
          },
          startTime:{
            initialValue:moment("00:00","HH:mm"),
          },
          endTime:{
            initialValue:moment("23:59","HH:mm"),
          },
          morningStartTime:{
            initialValue:moment("09:00","HH:mm"),
          },
          morningEndTime:{
            initialValue:moment("12:00","HH:mm"),
          },
          afternoonStartTime:{
            initialValue:moment("13:00","HH:mm"),
          },
          afternoonEndTime:{
            initialValue:moment("17:00","HH:mm"),
          },
          hasFives:{
            initialValue:'0'
          },
          noAutoCreateTask:{
            initialValue:'0'
          },
          hasDelayCancel:{
            initialValue:'0'
          },
          hasTimeMinMax:{
            initialValue:'0'
          },
        },
        isShowTimeMinMax:false,
        isShowDelayCancel:false,
      }
    },
    created () {
    },
    mounted() {
    },
    methods: {
      noonValueChangeMorning(newValue){
        let values=this.form.getFieldsValue(["afternoonPlanNum"])
        this.addPlanNum(values.afternoonPlanNum,newValue)
      },
      noonValueChangeAfternoon(newValue){
        let values=this.form.getFieldsValue(["morningPlanNum"])
        this.addPlanNum(values.morningPlanNum,newValue)
      },
      addPlanNum(Morning,Afternoon){
        let adds=(Morning?Morning:0)+(Afternoon?Afternoon:0)
        this.$nextTick(()=>{
          this.form.setFieldsValue({
            planNum:adds
          })
        })
      },
      planTypeChange(newVal){
        if(newVal=="day"){
          this.showHasNoon=true
        }else{
          this.showHasNoon=false
        }
      },
      hasNoonChange(e){
        this.hasNoonValue=e.target.value=="1"?true:false;
        if(this.hasNoonValue){
          let values=this.form.getFieldsValue(["afternoonPlanNum","morningPlanNum"])
          this.addPlanNum(values.afternoonPlanNum,values.morningPlanNum)
        }
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        //编辑页面禁止修改角色编码
        if(this.model.id){
          this.roleDisabled = true;
        }else{
          this.roleDisabled = false;
        }
        this.$nextTick(() => {
          let data=pick(this.model,'planNum','planType','roleType','roleName','hasNoon',"morningPlanNum","afternoonPlanNum","morningStartTime","morningEndTime","afternoonStartTime","afternoonEndTime","startTime","endTime","hasTemporaryTasks","hasFives","delayNum","cancelNum","inspectionMaxTime","inspectionMinTime","noAutoCreateTask","hasTimeMinMax","hasDelayCancel");
          data.morningStartTime=moment(data.morningStartTime?data.morningStartTime:"08:00", 'HH:mm')
          data.morningEndTime=moment(data.morningEndTime?data.morningEndTime:"12:00", 'HH:mm')
          data.afternoonStartTime=moment(data.afternoonStartTime?data.afternoonStartTime:"13:00", 'HH:mm')
          data.afternoonEndTime=moment(data.afternoonEndTime?data.afternoonEndTime:"17:00", 'HH:mm')
          data.startTime=moment(data.startTime?data.startTime:"00:00", 'HH:mm')
          data.endTime=moment(data.endTime?data.endTime:"23:59", 'HH:mm')
          this.handleHasTimeMinMaxChange({target:{value:data.hasTimeMinMax}})
          this.handleHasDelayCancelChange({target:{value:data.hasDelayCancel}})
          if(this.model.hasNoon==="0"){
            data.morningPlanNum="";
            data.afternoonPlanNum="";
          }
          this.form.setFieldsValue(data);
          let values=pick(data,'planType','hasNoon',"morningPlanNum","afternoonPlanNum")
          if(values.hasNoon==="1"){
            this.addPlanNum(values.afternoonPlanNum,values.morningPlanNum);
          }
          this.planTypeChange(values.planType)
          this.hasNoonChange({target:{value:values.hasNoon}})
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, fieldsValue) => {
          if (!err) {
            console.log("fieldsValue");
            console.log(fieldsValue);
            const values={
              ...fieldsValue,
              morningStartTime:fieldsValue.morningStartTime.format('HH:mm'),
              morningEndTime:fieldsValue.morningEndTime.format('HH:mm'),
              afternoonStartTime:fieldsValue.afternoonStartTime.format('HH:mm'),
              afternoonEndTime:fieldsValue.afternoonEndTime.format('HH:mm'),
              startTime:fieldsValue.startTime.format('HH:mm'),
              endTime:fieldsValue.endTime.format('HH:mm'),
            }
            let formData = Object.assign(this.model, values);
            let obj=editInspectionRoleOfGeneral(formData);
            that.confirmLoading = true;
            obj.then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateRoleCode(rule, value, callback){
        if(/[\u4E00-\u9FA5]/g.test(value)){
          callback("角色编码不可输入汉字!");
        }else{
          var params = {
            tableName: "sys_role",
            fieldName: "role_code",
            fieldVal: value,
            dataId: this.model.id,
          };
          duplicateCheck(params).then((res)=>{
            if(res.success){
              callback();
            }else{
              callback(res.message);
            }
          });
        }
      },
      handleHasTimeMinMaxChange(e){
        if(e.target.value=="1"){
          this.isShowTimeMinMax=true
        }else{
          this.isShowTimeMinMax=false
        }
      },
      handleHasDelayCancelChange(e){
        if(e.target.value=="1"){
          this.isShowDelayCancel=true
        }else{
          this.isShowDelayCancel=false
        }
      }
    }
  }
</script>

<style lang="less">
.div-flex{
  display: flex;
  justify-content: flex-start;
  .ant-input-number{
    border-radius: 4px 0px 0px 4px !important;
  }
  .input-addonafter-count{
    width: 71px;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    border-collapse: separate;
    border-spacing: 0;
    margin: 0;
    box-sizing: border-box;
    white-space: nowrap;
    vertical-align: middle;
    position: relative;
    padding: 0 11px;
    color: rgba(0, 0, 0, 0.65);
    font-weight: normal;
    font-size: 14px;
    line-height: 1;
    text-align: center;
    background-color: #fafafa;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    transition: all 0.3s;
    height: 40px;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    line-height: 40px;
  }
}
</style>